import {AbstractService} from 'services/AbstractService';

const ROLES_LIST_URL = '/api/roles';

export class RolesService extends AbstractService {
  getRolesList () {
    return this.client.get(ROLES_LIST_URL);
  }
}
